import { render, staticRenderFns } from "./DetailComplaintUpdated.vue?vue&type=template&id=15c8c383"
import script from "./DetailComplaintUpdated.vue?vue&type=script&lang=js"
export * from "./DetailComplaintUpdated.vue?vue&type=script&lang=js"
import style0 from "./DetailComplaintUpdated.vue?vue&type=style&index=0&id=15c8c383&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports